module.exports = __webpack_public_path__ + "img/leave_room.d3d2acce.svg";